<template>
  <q-dialog v-model="dialog" persistent>
    <q-card flat style="min-width: 456px">
      <q-toolbar class="bg-white text-dark">
        <q-toolbar-title> Tag </q-toolbar-title>
        <q-btn flat round dense icon="mdi-close" @click="onClose" />
      </q-toolbar>
      <q-toolbar class="bg-white text-dark">
        <q-toolbar-title>
          {{ $t('creative') }} - {{ creativeData.id }} | {{ $t('campaign') }}:
          {{ creativeData.campaign_name }}
        </q-toolbar-title>
      </q-toolbar>

      <q-card-section>
        <div class="row">
          <div class="col-12 q-pt-sm">
            <q-select
              v-model="selectedManager"
              :options="managersList"
              :label="$t('manager')"
              outlined
              option-label="name"
              option-value="user_id"
              clearable
              :disable = "managersList.length === 0"
            />
          </div>

          <div class="col-12 q-pt-sm">
            <q-select
              ref="channelSelect"
              v-model="selectedChannels"
              :options="channelFiltered"
              multiple
              :label="$t('channels')"
              outlined
              use-chips
              @filter="filterChannels"
              use-input
              option-label="site_name"
              option-value="site_id"
            >
              <template v-slot:before-options>
                <q-item
                  clickable
                  @click="
                    () => {
                      if (selectedChannels === channelFiltered) {
                        selectedChannels = [];
                      } else {
                        selectedChannels = channelFiltered;
                        $refs.channelSelect.hidePopup();
                      }
                    }
                  "
                >
                  <q-item-section class="text-bold"> {{ $t('select_all') }} </q-item-section>
                </q-item>
              </template>
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey"> {{ $t('no_channels_available') }} </q-item-section>
                </q-item>
              </template>
              <template v-slot:selected-item="scope">
                <q-chip
                  removable
                  size="0.8rem"
                  @remove="scope.removeAtIndex(scope.index)"
                  :tabindex="scope.tabindex"
                  color="primary"
                  square
                  icon-remove="close"
                  text-color="white"
                  input-class="text-caption"
                >
                  {{ scope.opt.site_name }}
                </q-chip>
              </template>
            </q-select>
          </div>
        </div>
      </q-card-section>
      <!-- <q-separator spaced inset /> -->
      <q-card-actions align="right" class="q-mr-sm">
        <q-btn unelevated outline no-caps :label="$t('cancel')" class="q-px-md" color="primary" @click="onClose" />
        <q-btn
          v-if="creativeSelect?.type_name != 'emailmkt'"
          :disable="disableBtnExport"
          unelevated
          no-caps
          :label="$t('export_csv')"
          class="q-px-md"
          color="primary"
          @click="exportTableCsv(shortLinks, columnsCsv, `CriativoID-${creativeData.id}`)"
        />
        <q-btn
          unelevated
          class="q-px-md"
          no-caps
          :loading="loading"
          :label="$t('generate_tag')"
          color="primary"
          @click="onGenerate"
          :disable="selectedChannels === null || selectedChannels.length === 0"
        />
      </q-card-actions>
      <q-card-section v-for="(shortLink, index) in shortLinks" :key="index">
        <q-separator spaced />
        <q-item v-if="shortLink.shortLink.destination_url">
          <q-item-section>
            <q-item-label overline>{{ shortLink.siteName }}</q-item-label>
            <q-item-label>
              <q-input
                outlined
                :label="$t('redirect_url')"
                readonly
                type="text"
                :value="shortLink.shortLink.destination_url"
              />
            </q-item-label>
          </q-item-section>
          <q-item-section avatar>
            <q-btn
              round
              color="primary"
              @click="clickToCopy(shortLink.shortLink.destination_url)"
              icon="content_copy"
            />
          </q-item-section>
        </q-item>
        <q-item v-if="shortLink.shortLink.image_url">
          <q-item-section>
            <q-item-label overline>{{ shortLink.siteName }}</q-item-label>
            <q-item-label>
              <q-input outlined :label="$t('image_url')" readonly type="text" :value="shortLink.shortLink.image_url" />
            </q-item-label>
          </q-item-section>
          <q-item-section avatar>
            <q-btn round color="primary" @click="clickToCopy(shortLink.shortLink.image_url)" icon="content_copy" />
          </q-item-section>
        </q-item>
        <q-item v-if="shortLink.shortLink.html">
          <q-item-section>
            <q-item-label overline>{{ shortLink.siteName }}</q-item-label>
            <q-item-label v-if="shortLink.shortLink.html">
              <q-input readonly :value="shortLink.shortLink.html" type="textarea" label="Html" outlined>
                <template v-slot:append></template>
              </q-input>
            </q-item-label>
          </q-item-section>
          <q-item-section avatar>
            <q-btn round color="primary" @click="clickToCopy(shortLink.shortLink.html)" icon="content_copy" />
          </q-item-section>
        </q-item>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import CreativeMixin from '@/mixins/CreativeMixin';
import CreativesService from '../../services/CreativesService';
import AdvertiserService from '../../services/AdvertiserService';

export default {
  mixins: [CreativesService, CreativeMixin, AdvertiserService],
  data() {
    return {
      active: false,
      dialog: false,
      creativeData: {
        campaign_name: null,
        id: null
      },
      dialogFullScreen: false,
      maximizedToggle: true,
      channelList: [],
      channelFiltered: [],
      channelListAll: [],
      selectedChannels: null,
      shortLinks: [],
      loading: false,
      columnsCsv: [],
      selectedManager: null,
      managersList: [],
      managersListAll: []
    };
  },

  computed: {
    disableBtnExport: {
      get() {
        return this.shortLinks.length === 0;
      }
    }
  },

  props: {
    id: {
      type: [Number, String],
      default: null
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    initializeColumns() {
      if (this.shortLinks.length > 0) {
        const firstRow = this.shortLinks[0].shortLink;
        this.columnsCsv = [
          {
            name: 'id_site',
            label: this.$t('channel_id'),
            field: (row) => row.shortLink.id_site
          },
          {
            name: 'siteName',
            label: this.$t('channel_name'),
            field: 'siteName'
          }
        ];
        if (firstRow.destination_url) {
          this.columnsCsv.push({
            name: 'destination_url',
            label: this.$t('shortened_link'),
            field: (row) => row.shortLink.destination_url
          });
        }
        if (firstRow.image_url) {
          this.columnsCsv.push({
            name: 'image_url',
            label: this.$t('link_image'),
            field: (row) => row.shortLink.image_url
          });
        }
      }
    },

    filterChannels(val, update) {
      if (val === '') {
        update(() => {
          this.channelFiltered = this.channelList;
        });
        return;
      }
      update(() => {
        const needle = val.toLowerCase();
        this.channelFiltered = this.channelList.filter((v) => v.site_name.toLowerCase().indexOf(needle) > -1);
      });
    },
    onClose() {
      this.ActionSetCreativeSelect('');
      this.dialog = false;
      this.shortLinks = [];
      this.options = [];
      this.selectedChannels = null;
      this.selectedManager = null;
      this.$router.push({ name: 'CreativeList' });
    },

    onSave() {},

    openFullScreen() {
      this.dialogFullScreen = !this.dialogFullScreen;
    },

    onGenerate() {
      const hasRestrictedChannels = this.creativeData.id_site && this.creativeData.id_site.trim() !== '';

      if (!hasRestrictedChannels) {
        this.selectedChannels.map(this.generateTag);
        return;
      }

      const restrictedChannels = this.creativeData.id_site.split(',').map((id) => parseInt(id));

      const hasNonRestrictedChannels = this.selectedChannels.some(
        (channel) => !restrictedChannels.includes(parseInt(channel.site_id))
      );

      if (hasNonRestrictedChannels) {
        this.$q
          .dialog({
            title: this.$t('alert'),
            message:
              this.$t('creative_has_restricted_channels_warning'),
            persistent: true,
            ok: true,
            cancel: this.$t('cancel')
          })
          .onOk(() => {
            this.selectedChannels.map(this.generateTag);
          });
      } else {
        this.selectedChannels.map(this.generateTag);
      }
    },

    async getChannelsApproved() {
      try {
        const { data, status } = await this.listSitesApprovedDetailsByCampaign(this.creativeData.id_campaign);
        if (status == 200) {
          this.channelList = data;
          this.channelFiltered = data;
          this.channelListAll = data;

          this.managersList = this.managersListAll.filter((manager) =>
            this.channelList.some((channel) => channel.comercial_manager_id === manager.user_id)
          );
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getManagers() {
      try {
        const { data, status } = await this.$http.get(`user/managers-unblocked`);
        if (status === 200) {
          this.managersListAll = data.sort((a, b) => a.name.localeCompare(b.name, 'pt', { sensitivity: 'base' }));
          this.managersList = this.managersListAll;
        }
      } catch (error) {
        this.errorNotify(this.$t('error_loading_campaign_managers'), error);
      }
    },

    async getCreativeById(id) {
      try {
        const { data, status } = await this.getCreativeId(id);
        if (status == 200) {
          this.creativeData = data.creatives;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async generateTag(value) {
      this.loading = true;

      const existingShortLink =
        this.shortLinks.length > 0 ? this.shortLinks.map((item) => parseInt(item.shortLink.id_site)) : [];
      if (!existingShortLink.includes(value.site_id)) {
        try {
          const { data, status } = await this.getShortned(this.id, value.site_id);
          if (status == 200) {
            this.shortLinks.push({
              shortLink: data,
              siteName: this.channelList.find((item) => item.site_id == data.id_site).site_name
            });
          }
        } catch (error) {
          this.errorNotify(this.$t('error_generating_tag'));
        }
      }
      this.loading = false;
    }
  },

  watch: {
    selectedManager() {
      if (this.selectedManager) {
        this.channelList = this.channelListAll.filter(
          (channel) => channel.comercial_manager_id === this.selectedManager.user_id
        );
      } else {
        this.getChannelsApproved();
      }
    },

    id() {
      if (this.id !== null) {
        this.dialog = true;
        this.shortLinks = [];
        this.options = [];
        this.selectedChannels = null;
        this.getCreativeById(this.id);
      }
    },

    creativeData() {
      if (typeof this.creativeData.id_campaign !== undefined) {
        this.getChannelsApproved();
      }
    },

    shortLinks: {
      handler() {
        this.initializeColumns();
      },
      immediate: true
    }
  },
  created() {
    if (this.id !== null) {
      this.dialog = true;
      this.shortLinks = [];
      this.options = [];
      this.selectedChannels = null;
      this.getCreativeById(this.id);
    }
    this.getManagers();
  }
};
</script>

<style></style>
